import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { bootstrapCalendarFill } from '@ng-icons/bootstrap-icons';
import { NgIconComponent, provideIcons, provideNgIconsConfig } from '@ng-icons/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AsyncPipe, JsonPipe } from '@angular/common';
import dayjs from 'dayjs';
import { MasterContactService } from '../../../../../../../shared/master-contact/master-contact.service';
import { RemoveNgbDateDatepickerDefaultValidation } from '../../../../../../../shared/directives/NgbDateTime/disable-default-validation.directive';
import { AddressPickerComponent } from '../../../../../../../shared/components/address-picker/address-picker.component';
import { CustomDateFormatter } from '../../../../../../../shared/ngb-datepicker/NgbDateCustomParserFormatter';

@Component({
  selector: 'app-delivery-to-form',
  standalone: true,
  imports: [AddressPickerComponent, ReactiveFormsModule, NgbTimepickerModule, NgbDatepickerModule, NgIconComponent, NgSelectModule, JsonPipe, AsyncPipe, RemoveNgbDateDatepickerDefaultValidation],
  providers: [
    provideNgIconsConfig({
      size: '0.5em'
    }),
    {
      provide: NgbDateParserFormatter,
      useClass: CustomDateFormatter
    }
  ],
  templateUrl: './delivery-to-form.component.html',
  styleUrl: './delivery-to-form.component.scss',
  viewProviders: [provideIcons(
    {
      bootstrapCalendarFill
    }
  ),
  ]
})
export class DeliveryToFormComponent implements OnInit {
  @Input()
  formGroup!: FormGroup;

  @Input()
  disableEmitter!: EventEmitter<boolean>;

  lockdown: boolean = false;

  constructor(private formBuilder: FormBuilder, private masterContactService: MasterContactService) { }

  ngOnInit() {
    this.disableEmitter.subscribe((value) => {
      if (value) {
        this.formGroup.disable({ emitEvent: false });
      } else {
        this.formGroup.enable();
      }
      this.lockdown = value;
    });
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('deliverTo', this.formBuilder.group({
      addressSelection: this.formBuilder.group({}, [Validators.required]),
      preciseLocationOptions: this.formBuilder.group({}),
      deliverDateTime: this.formBuilder.group({
        date: this.formBuilder.control({
          year: dayjs().year(),
          // month is 0 based
          month: dayjs().month() + 1,
          day: dayjs().date()
        }, [Validators.required]),
        time: this.formBuilder.control({
          hour: 12,
          minute: 0
        }, [Validators.required])
      }),
      // 2000 character limit  is set at the database level for the column this is mapped to 'DespatchComments'
      instructions: this.formBuilder.control("", [Validators.maxLength(2000)]),
      siteContactId: this.formBuilder.control(0),
      siteContact: this.formBuilder.control(null),
      siteContactPhone: this.formBuilder.control(''),
      siteContactEmail: this.formBuilder.control('', [Validators.email]),
    }));

    this.formGroup.get('deliverTo.deliverDateTime')?.valueChanges.subscribe((value) => {
      if (!value.date) {
        value.date = {
          year: dayjs().year(),
          month: dayjs().month() + 1,
          day: dayjs().date()
        };
      }

      if (!value.time) {
        value.time = { hour: 12, minute: 0 };
      }

      this.formGroup.get('deliverTo.deliverDateTime')?.patchValue(value, { emitEvent: false });
    });
  }

  customerContactNameAltered() {
    const siteContactName = this.formGroup.get('deliverTo.siteContact')?.value;
    this.formGroup.get('deliverTo.siteContact')?.patchValue(siteContactName?.trim(), { emitEvent: false });
  }

  customerContactPhoneAltered() {
    const siteContactPhone = this.formGroup.get('deliverTo.siteContactPhone')?.value;
    this.formGroup.get('deliverTo.siteContactPhone')?.patchValue(siteContactPhone?.trim(), { emitEvent: false });
  }

  getFormGroup() {
    if (!this.formGroup.get('deliverTo')) {
      this.initializeForm();
    }
    return this.formGroup.get('deliverTo') as FormGroup;
  }

}
